export interface SupervisoryAuthorityInfo {
  name: string;
  address: string;
  state: string;
}

export const supervisoryAuthorities: Record<string, SupervisoryAuthorityInfo> = {
  'Baden-Württemberg': {
    name: 'Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg',
    address: 'Heilbronner Straße 35, 70191 Stuttgart',
    state: 'Baden-Württemberg',
  },
  Bayern: {
    name: 'Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)',
    address: 'Promenade 18, 91522 Ansbach',
    state: 'Bayern',
  },
  Berlin: {
    name: 'Berliner Beauftragte für Datenschutz und Informationsfreiheit',
    address: 'Alt-Moabit 59-61, 10555 Berlin',
    state: 'Berlin',
  },
  Brandenburg: {
    name: 'Die Landesbeauftragte für den Datenschutz und für das Recht auf Akteneinsicht',
    address: 'Stahnsdorfer Damm 77, 14532 Kleinmachnow',
    state: 'Brandenburg',
  },
  Bremen: {
    name: 'Der Landesbeauftragte für Datenschutz und Informationsfreiheit',
    address: 'Georgstraße 122-124, 27570 Bremerhaven',
    state: 'Bremen',
  },
  Hamburg: {
    name: 'Der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit',
    address: 'Ludwig-Erhard-Str 22, 20459 Hamburg',
    state: 'Hamburg',
  },
  Hessen: {
    name: 'Der Hessische Beauftragte für Datenschutz und Informationsfreiheit',
    address: 'Gustav-Stresemann-Ring 1, 65189 Wiesbaden',
    state: 'Hessen',
  },
  'Mecklenburg-Vorpommern': {
    name: 'Der Landesbeauftragte für Datenschutz und Informationsfreiheit',
    address: 'Werderstraße 74a, 19055 Schwerin',
    state: 'Mecklenburg-Vorpommern',
  },
  Niedersachsen: {
    name: 'Der Landesbeauftragte für den Datenschutz',
    address: 'Prinzenstraße 5, 30159 Hannover',
    state: 'Niedersachsen',
  },
  'Nordrhein-Westfalen': {
    name: 'Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen',
    address: 'Kavalleriestr. 2-4, 40213 Düsseldorf',
    state: 'Nordrhein-Westfalen',
  },
  'Rheinland-Pfalz': {
    name: 'Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit',
    address: 'Hintere Bleiche 34, 55116 Mainz',
    state: 'Rheinland-Pfalz',
  },
  Saarland: {
    name: 'Unabhängiges Datenschutzzentrum Saarland',
    address: 'Fritz-Dobisch-Straße 12, 66111 Saarbrücken',
    state: 'Saarland',
  },
  Sachsen: {
    name: 'Sächsische Datenschutz- und Transparenzbeauftragte',
    address: 'Maternistraße 17, 01067 Dresden',
    state: 'Sachsen',
  },
  'Sachsen-Anhalt': {
    name: 'Landesbeauftragter für den Datenschutz Sachsen-Anhalt',
    address: 'Otto-von-Guericke-Straße 34a, 39104 Magdeburg',
    state: 'Sachsen-Anhalt',
  },
  'Schleswig-Holstein': {
    name: 'Unabhängiges Landeszentrum für Datenschutz',
    address: 'Holstenstraße 98, 24103 Kiel',
    state: 'Schleswig-Holstein',
  },
  Thüringen: {
    name: 'Thüringer Landesbeauftragter für den Datenschutz und die Informationsfreiheit',
    address: 'Häßlerstraße 8, 99096 Erfurt',
    state: 'Thüringen',
  },
};
